import React, {useRef, useState} from 'react'
import {
  CardBox,
  CardButtonBox,
  CardText,
  CardTitle,
  Divider,
} from '../BaseCard/styles'
import ExamStatusIcon from '../../../../images/icons/new-dashboard/exam-status-icon.svg'
import {Button} from '../../../../components/button'
import DivisionDatepicker from '../../DivisionDatepicker'
import {CollapseBox, DivisionsBox} from './styles'
import {ExamDateFilter} from '.'
import {useWindowDimensions} from '../../../../hooks/useWindowDimensions'
import {Link} from 'react-router-dom'
import {Attempt} from '../../../../redux/reportExamStatus'
import {Organization} from '../../../../redux/courses'
import {useAuth} from '../../../../components/AuthProvider'

type Props = {
  onSubmit: () => void
  onChangeDateFilter: (
    value: string,
    courseId?: string,
    attemptId?: string,
  ) => void
  dateFilter: ExamDateFilter[]
  examReports?: Attempt[]
  organization?: Organization
  isSubmitting: boolean
}

const View = ({
  onSubmit,
  onChangeDateFilter,
  isSubmitting,
  dateFilter,
  examReports,
  organization,
}: Props) => {
  const {isMobile} = useWindowDimensions()
  const auth = useAuth()

  const [isExpanded, setIsExpanded] = useState(!isMobile)
  const contentRef = useRef<HTMLDivElement | null>(null)

  const getDateByDivision = (courseId: string) => {
    return (
      dateFilter.find(filter => filter.courseId === courseId)?.examDate || ''
    )
  }

  const courses = organization?.courses.filter(course => {
    return ['PcM', 'PjM', 'PA', 'PPD', 'PDD', 'CE'].includes(
      course.abbreviation,
    )
  })

  return (
    <CardBox>
      <button
        onClick={() => {
          if (isMobile) setIsExpanded(!isExpanded)
        }}
        style={{
          all: 'unset',
          cursor: 'pointer',
          display: 'block',
          width: '100%',
        }}
        aria-expanded={isExpanded}
      >
        <CardTitle>
          <img src={ExamStatusIcon} alt="Exam Status" />
          <span>Exam Status</span>
        </CardTitle>
        <Divider />
        <CardText>
          Set your exam date to start your countdown and receive personalized
          study guidance for each ARE Division.
        </CardText>
      </button>
      <CollapseBox
        $isExpanded={isExpanded}
        height={contentRef.current?.scrollHeight}
        ref={contentRef}
      >
        <DivisionsBox>
          {courses?.map((course, key) => {
            const reportStatus = examReports?.find(
              ur => ur.courseId === course.id && ur.passed !== false,
            )

            return (
              <React.Fragment key={`exam-sts-${key}`}>
                <DivisionDatepicker
                  division={course.abbreviation}
                  onChangeDateFilter={onChangeDateFilter}
                  dateFilter={getDateByDivision(course.id)}
                  reportStatus={reportStatus}
                  courseId={course.id}
                />
              </React.Fragment>
            )
          })}
        </DivisionsBox>
        <CardButtonBox>
          <Button
            color="primary"
            onClick={onSubmit}
            disabled={isSubmitting || dateFilter.length === 0}
          >
            Register Now
          </Button>
        </CardButtonBox>
        {auth.isAuthenticated && (
          <CardText style={{marginTop: '16px'}}>
            <em>
              If you haven't scheduled your exam yet,{' '}
              <Link to={'/profile/settings/are-progress'}>click here</Link> to
              get started.
            </em>
          </CardText>
        )}
      </CollapseBox>
    </CardBox>
  )
}

export default View
